(function documentTypeControllerDefinition() {
    'use strict';

    angular.module('DocumentType')
        .controller('DocumentTypeFindController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminDocumentTypeService', 'authExtend', 'functionService','$filter',
            function documentTypeController($scope, config, $state, $translate, $stateParams, errors, adminDocumentTypeService, authExtend, functionService, $filter) {
                $scope.find =
                    {
                        Name: '',
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName(),
                        showNoData: false,
                        app: {
                            id: config.appId()
                        }
                    };

                $scope.hideAddBtn = !authExtend.isInRole('DOCUMENTTYPE WRITE');
                $scope.hideImportExportBtn = !authExtend.isInRole('CTDT EXPORT IMPORT');
                $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');
                $scope.enableviewIndex = authExtend.isInRole('VIEW INDEX') || authExtend.isInRole('EDIT AND DELETE INDEX');

                if ($scope.allApps) {
                    functionService.getApps().then(function getOk(result) {
                        $scope.optionApps = result;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                }

                $scope.findAction = function () {

                    $scope.checkAll = false;
                    var name = $scope.find.organizationalUnitName;
                    var id = $scope.find.organizationalUnitId;

                    if (name == undefined && id != undefined) {
                        $scope.find.organizationalUnitId = undefined;
                    }

                    $scope.items = [];
                    $scope.find.showNoData = false;
                    $scope.setRequestFilters();

                    return adminDocumentTypeService.get($scope.find.Name, $scope.find.organizationalUnitId, undefined, $scope.find.app ? $scope.find.app.id : undefined ).then(function getOk(result) {
                        $scope.items = result;

                        if ($scope.items.length === 0)
                            $scope.find.showNoData = true;

                    }, function getError(error) {
                        errors.showError(error);
                    });

                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            docu.check = $scope.checkAll;
                        });
                    }
                };

                $scope.import = function () {
                    $state.go('document-type-import');
                };

                $scope.exportAll = function (version) {
                    var documentTypesToExport = [];

                    $scope.items.forEach(function (docType) {
                        if (docType.check) {
                            documentTypesToExport.push(docType.id);
                        }
                    });

                    if (documentTypesToExport.length > 0) {
                        if (version == "0") {
                            $scope.exportV0(documentTypesToExport);
                        }else if (version == "1") {
                            $scope.exportV1(documentTypesToExport);
                        }

                    }
                    else {
                        errors.showError("Debe Seleccionar al menos un Tipo Documental para exportar");
                    }
                };

                $scope.exportV0 = function(documentTypesToExport) {
                    var parameter = { version: "0", ids: documentTypesToExport };
                    return adminDocumentTypeService.exportToJson(parameter).then(function (result, data) {
                        console.log(result.headers);
                        var file = new Blob([result]);

                        saveAs(file, $scope.find.organizationalUnitName + '.edr');
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                $scope.exportV1 = function (documentTypesToExport) {
                    var parameter = { version: "1", ids: documentTypesToExport };
                    return adminDocumentTypeService.exportToJson(parameter).then(function (result, data) {
                        console.log(result.headers);
                        var file = new Blob([result]);

                        var today = new Date();

                        var filename = "Export_DefinicionTD_" + $scope.find.organizationalUnitName + "_" + $filter('date')(today, "yyyyMMdd") + ".zip";

                        saveAs(file, filename);
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                $scope.export = function (docType) {
                    var documentTypesToExport = [];
                    documentTypesToExport.push(docType.id);
                    $scope.exportV1(documentTypesToExport);
                };

                $scope.modify = function (documentType) {
                    $state.go('document-type-modify', { id: documentType.id });
                };

                $scope.view = function (documentType) {
                    $state.go('document-type-detail', { id: documentType.id });
                };

                $scope.add = function () {
                    $state.go('document-type-add');
                };

                $scope.metadata = function (documentType) {
                    $state.go('document-type-metadata', { id: documentType.id });
                };

                $scope.createFrom = function (documentType) {
                    $state.go('document-type-from-template', { id: documentType.id });
                }

                $scope.importSettings = function (documentType) {
                    $state.go('document-type-import-settings', { id: documentType.id });
                };

                $scope.setRequestFilters = function () {
                    if ($stateParams.name != '') {
                        $scope.find.Name = $stateParams.name;
                        $stateParams.name = '';
                    }
                }

                $scope.viewIndex = function (documentType) {
                    $state.go('dba-detail', { key: 'TD', id: documentType.id });
                };

                $scope.documentTypeShareable = function (documentType, isShareable) {

                    if (isShareable) {

                        return adminDocumentTypeService.share(documentType).then(function () {
                            errors.showSuccess('DocumentTypeShareableSucces');
                            documentType.isShareable = isShareable;
                        }, function (error) {
                            errors.showError(error);
                        });
                    } else {
                        return adminDocumentTypeService.notShare(documentType).then(function () {
                            documentType.isShareable = isShareable;
                            errors.showSuccess('DocumentTypeNotShareableSucces');
                        }, function (error) {
                            errors.showError(error);
                        });
                    }

                };

                $scope.load = function () {
                    $scope.findAction();
                }

                $scope.load();
            }
        ]);
})();